import { ANNA, CATALOG_MONTHLY, CATALOG_ONE_TIME, TRAINER_META } from "../../content/catalog";

export const LAB_HEADLINE = "Три тренажёра — один живой английский";
export const LAB_LEAD = "Звуки, слова и фразы от репетиторов для детей 7–9 лет.";
export const LAB_CTA = "Попробовать 7 дней";
export const LAB_SECONDARY = "Выбрать тренажёр";
export const LAB_TRUST = "Автор тренажёра не получает персональные данные ребёнка.";
export const LAB_BRAND = "Clever";
export const LAB_OTHER = "Другой дизайн";
export const LAB_NAV_TRAINERS = "Тренажёры";
export const LAB_NAV_TUTORS = "Репетиторам";
export const LAB_NAV_SIGNIN = "Войти";

export const LAB_SELLER = {
  name: ANNA.name,
  specialization: ANNA.specialization,
  bio: ANNA.bio,
};

export const LAB_PRICE = `Весь каталог: разово ${rub(CATALOG_ONE_TIME)} или ${rub(CATALOG_MONTHLY)} в месяц`;

export const LAB_TRAINERS = TRAINER_META.map((trainer, index) => ({
  emoji: ["🔊", "🎬", "🎭"][index] ?? "✨",
  title: trainer.title,
  goal: trainer.goal,
  meta: `${trainer.age} · ${trainer.duration} · ${trainer.lessons} занятий`,
}));

export const LAB_EXERCISE = {
  kicker: "Английские звуки",
  title: "Почувствуй звук /f/",
  lead: "Послушай fan. Повтори слово — верхние зубы слегка касаются нижней губы.",
  word: "fan",
  gloss: "вентилятор",
  example: "I hear a fan.",
  listen: "Послушать fan",
  speak: "Повторить самому",
  done: "Готово",
  status: {
    idle: "Сначала послушай слово fan.",
    listen: "Слушаем fan. Воздух выходит без голоса.",
    speak: "Повтори /f/ в начале fan.",
    done: "Готово — звук /f/ пойман.",
  },
} as const;

export type LessonPlay = keyof typeof LAB_EXERCISE.status;

export function rub(kopecks: number): string {
  return `${Math.round(kopecks / 100).toLocaleString("ru-RU")} ₽`;
}

export function speakFan(): void {
  if (typeof window === "undefined" || !window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const line = new SpeechSynthesisUtterance(LAB_EXERCISE.word);
  line.lang = "en-GB";
  window.speechSynthesis.speak(line);
}
